import React from "react";
import {
  Box,
  TextField,
  Button,
  IconButton,
  InputAdornment,
  FormControlLabel,
  Switch,
} from "@mui/material";

import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import ClearIcon from "@mui/icons-material/Clear";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import ViewListOutlinedIcon from "@mui/icons-material/ViewListOutlined";
import UploadOutlinedIcon from "@mui/icons-material/UploadOutlined";

// Import the useAuth hook and the ROLES enum
import { useAuth, ROLES } from "../../components/auth/AuthProvider";


export default function PortfolioHeaderActions(
  {
    searchText, onSearchChange, onExport, onOpenColumns, onOpenFilters,
    //  Add new props for the toggle
    myPortfolioOnly,
    onMyPortfolioToggle
  }
) {
  // Access the current role from AuthContext
  const { role } = useAuth();
  
  // Determine if the current user is a Partner user
  const isPartnerUser = role === ROLES.PARTNER;
  console.log('isPartnerUser:', isPartnerUser);
 
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        bgcolor: "#fff",
        p: 2,
        width: "100%",
      }}
    >
      {/* Left Section */}
      <Box display="flex" alignItems="center" gap={1.5}>
        {/* Search */}
        <TextField
          size="small"
          placeholder="Search"
          value={searchText}
          onChange={(e) => onSearchChange(e.target.value)}
          sx={{
            width: 220,
            "& .MuiOutlinedInput-root": {
              borderRadius: 20,
              fontSize: 13,
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchOutlinedIcon fontSize="small" color="action" />
              </InputAdornment>
            ),
            endAdornment: searchText ? (
              <InputAdornment position="end">
                <IconButton
                  size="small"
                  onClick={() => onSearchChange("")}
                  edge="end"
                  sx={{ p: 0.25 }}
                >
                  <ClearIcon sx={{ fontSize: 16, color: "#9CA3AF" }} />
                </IconButton>
              </InputAdornment>
            ) : null,
          }}
        />

        {/* Add Filter */}
        <Button
          variant="outlined"
          size="small"
          startIcon={<FilterAltOutlinedIcon />}
          sx={{
            borderRadius: 20,
            textTransform: "none",
            fontSize: 13,
            px: 2,
          }}
          onClick={onOpenFilters}
        >
          Add Filter
        </Button>

        {/* Column/List View */}
        <IconButton
          size="small"
          onClick={onOpenColumns}
          sx={{
            border: "1px solid #e5e7eb",
            borderRadius: "50%",
          }}
        >
          <ViewListOutlinedIcon fontSize="small" />
        </IconButton>
      </Box>

      {/* Right Section */}
      <Box display="flex" alignItems="center" gap={2}>
         {/* My Portfolio Only Toggle - Only visible for Partner users */}
        {isPartnerUser && (
          <FormControlLabel
            control={
              <Switch
                checked={myPortfolioOnly}
                onChange={(e) => onMyPortfolioToggle(e.target.checked)}
                size="small"
              />
            }
            label="My Portfolio Only"
            sx={{
              "& .MuiFormControlLabel-label": {
                fontSize: 13,
                color: "#374151",
              },
            }}
          />
        )}
        <Button
          variant="outlined"
          size="small"
          startIcon={<UploadOutlinedIcon />}
          onClick={onExport}
          sx={{
            borderRadius: 20,
            textTransform: "none",
            fontSize: 13,
            px: 2,
            mr: 3
          }}
        >
          Export
        </Button>
      </Box>
    </Box>
  );
}
